import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { userAtom } from "../../recoil/userAtom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Refund_QnA from "./Refund_QnA";
import FullPageWithHeaderAndProgressV2 from "../container/FullPageWithHeaderAndProgressV2";
import Refund_Submit from "./Refund_Submit";
import Refund_Final_1 from "./Refund_Final_1";
import Refund_Final_3 from "./Refund_Final_3";
import Refund_Final_2 from "./Refund_Final_2";
import SelfCommitmentContent from "../../components/commitment/SelfCommitmentContent";
import Refund_Request_1 from "./Refund_Request_1";
import CustomModal from "../../components/common/CustomModal";
import useIsInappWebview from "../../hooks/useIsInappWebview";
import { sendMessage } from "../../utils/webview";
import { pcSideTabAtom } from "../../recoil/pcSideTabAtom";
import useMixpanelWeb from "../../hooks/useMixpanelWeb";
import { useQuery } from "@tanstack/react-query";
import {
  COMMITMENT_DETAIL_ENDPOINT,
  COMMITMENT_DOMAIN,
  commitmentApi,
} from "../../api/commitmentApi";

interface RefundStep {
  seq: number;
  title?: string;
  hideHeader?: boolean;
  hideProgress?: boolean;
  disableBack?: boolean;
  progressDelta?: number;
  highlightBackground?: boolean;
  content: React.ReactNode;
  hideClose?: boolean;
}

const steps: RefundStep[] = [
  {
    seq: 0,
    title: "환불 신청",
    hideProgress: true,
    content: <SelfCommitmentContent isForWithdrawal={false} />,
  },
  {
    seq: 1,
    title: "환불 신청",
    content: (
      <Refund_QnA
        pageSeq={1}
        questionId={1}
        mainQuestion={"나는 내가 변화할 수 있다는 사실을"}
        leftQuestion={"믿지\n" + "않았다"}
        rightQuestion={"굳게\n" + "믿었다"}
      />
    ),
  },
  {
    seq: 2,
    title: "환불 신청",
    content: (
      <Refund_QnA
        pageSeq={2}
        questionId={2}
        mainQuestion={"나는 변화를 위해 시간과 노력을"}
        leftQuestion={"충분히 투자하지\n" + "않았다"}
        rightQuestion={"후회 없을 만큼\n" + "투자했다"}
      />
    ),
  },
  {
    seq: 3,
    title: "환불 신청",
    content: (
      <Refund_QnA
        pageSeq={3}
        questionId={3}
        mainQuestion={"나는 포기하고 싶은 마음을"}
        leftQuestion={"이겨내지 못하고\n" + "굴복했다"}
        rightQuestion={"이겨내며\n" + "앞으로 나아갔다"}
      />
    ),
  },
  {
    seq: 4,
    title: "환불 신청",
    content: (
      <Refund_Submit
        pageSeq={4}
        questionId={4}
        contentTextList={[
          "삶의 무게 속에서 새로운 시작을 결심하는 건 결코 쉽지 않은 일이었을 겁니다.",
          "디스턴싱을 시작하기로 한 선택은 분명 큰 용기였습니다.",
          "용기를 보였던 그 당시의 나는, 포기하려는 지금의 나에게 어떠한 말을 해줄 것 같나요?",
        ]}
        placeholder={
          "프로그램을 시작하며 결심했던 당시의 마음을 떠올리며 적어보세요"
        }
      />
    ),
  },
  {
    seq: 5,
    title: "환불 신청",
    content: (
      <Refund_QnA
        pageSeq={5}
        questionId={5}
        mainQuestion={"나는 나와 약속한 일을"}
        leftQuestion={"잘해내지 못할까\n" + "걱정만 했다"}
        rightQuestion={"완벽치 않더라도\n" + "해내었다"}
      />
    ),
  },
  {
    seq: 6,
    title: "환불 신청",
    content: (
      <Refund_QnA
        pageSeq={6}
        questionId={6}
        mainQuestion={"나는 새로운 방식과 관점을"}
        leftQuestion={"받아들이기를\n" + "거부했다"}
        rightQuestion={"열린 마음으로\n" + "받아들였다"}
      />
    ),
  },
  {
    seq: 7,
    title: "환불 신청",
    content: (
      <Refund_Submit
        pageSeq={7}
        questionId={7}
        contentTextList={[
          "돌아보면 생각보다 많은 것을 해냈을지도 모릅니다.",
          "디스턴싱이라는 개념을 알게 되었고, 나를 도와줄 코치와 만나, 이제 그 기술을 익히기 시작했으니까요.",
          "목표를 이룬 미래의 나는, 포기하려는 지금의 나에게 어떠한 말을 해줄 것 같나요?",
        ]}
        placeholder={"프로그램을 시작하며 꿈꾸었던 미래를 떠올리며 적어보세요"}
      />
    ),
  },
  {
    seq: 8,
    title: "환불 신청",
    content: (
      <Refund_QnA
        pageSeq={8}
        questionId={8}
        mainQuestion={"나는 마주치는 어려움들을"}
        leftQuestion={"외면하고\n" + "회피했다"}
        rightQuestion={"마주하고자\n" + "노력했다"}
      />
    ),
  },
  {
    seq: 9,
    title: "환불 신청",
    content: (
      <Refund_QnA
        pageSeq={9}
        questionId={9}
        mainQuestion={"나는 코치 선생님에게 도움을"}
        leftQuestion={"구하려는 시도조차\n" + "하지 않았다"}
        rightQuestion={"구하며\n" + "함께 고민했다"}
      />
    ),
  },
  {
    seq: 10,
    title: "환불 신청",
    content: (
      <Refund_Submit
        pageSeq={10}
        questionId={10}
        contentTextList={[
          "새로운 지식을 배우고 낯선 감정을 마주하는 일은 결코 쉽지 않습니다.",
          "그렇기에 이 여정을 코치와 함께하는 것이지요.",
          "내가 나의 담당 코치라면, 포기하려는 지금의 나에게 어떠한 말을 해줄 것 같나요?",
        ]}
        placeholder={
          "무한히 나를 지지하고 아껴주는 코치 선생님을 떠올리며 적어보세요"
        }
      />
    ),
  },
  {
    seq: 11,
    hideProgress: true,
    highlightBackground: true,
    content: <Refund_Final_1 />,
  },
  {
    seq: 12,
    hideProgress: true,
    highlightBackground: true,
    content: <Refund_Final_2 />,
  },
  {
    seq: 13,
    hideProgress: true,
    highlightBackground: true,
    content: <Refund_Final_3 />,
  },
  {
    seq: 14,
    title: "환불 신청",
    hideProgress: true,
    content: <SelfCommitmentContent isForWithdrawal={true} />,
  },
  {
    seq: 15,
    hideProgress: true,
    content: <Refund_Request_1 />,
  },
];

function findIndexByStepInfo(steps: RefundStep[], seq: number): number {
  return steps.findIndex((step) => step.seq === seq);
}

export default function RefundScreen() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);
  const isInappWebview = useIsInappWebview();
  const setPCSideTab = useSetRecoilState(pcSideTabAtom);

  const [showNoPaymentModal, setShowNoPaymentModal] = useState(false);

  useEffect(() => {
    if (user && (user.subscription?.isSubscribing === false || user.refundPolicyType !== "c")) {
      setShowNoPaymentModal(true);
    }
  }, [user]);

  const handleExit = () => {
    if (isInappWebview) {
      sendMessage(
        JSON.stringify({
          event: "navigate_back",
        })
      );
    } else {
      navigate("/", { replace: true });
    }
  };

  const seq = Number.parseInt(searchParams.get("seq") || "0");

  const currentStepIndex = Math.min(
    Math.max(findIndexByStepInfo(steps, seq), 0),
    steps.length - 1
  ); // 유효한 범위 내로 제한

  const currentStep = steps[currentStepIndex];

  // Fetch commitment detail to determine if signature exists, used for back-navigation skip logic
  const { data: commitmentDetail, isLoading: isLoadingCommit } = useQuery(
    [COMMITMENT_DOMAIN, COMMITMENT_DETAIL_ENDPOINT, user?.userId],
    () => commitmentApi.getDetail(),
    {
      staleTime: 1000 * 60,
    }
  );

  const rawSig = (commitmentDetail as any)?.result?.signature as
    | string
    | undefined
    | null;
  const hasSignature = !!rawSig;

  const handleBack = () => {
    // Determine the previous navigable step, skipping signature steps when signature is absent
    let targetIndex = currentStepIndex - 1;

    const shouldSkipSignature = !isLoadingCommit && !hasSignature;

    while (targetIndex >= 0) {
      const step = steps[targetIndex];
      const isSignatureStep = step.seq === 0 || step.seq === 14;
      if (isSignatureStep && shouldSkipSignature) {
        targetIndex -= 1;
        continue;
      }
      break;
    }

    if (targetIndex < 0) {
      if (isInappWebview) {
        sendMessage(
          JSON.stringify({
            event: "navigate_back",
          })
        );
      } else {
        navigate("/", { replace: true });
        // setPCSideTab("mypage")
        // navigate(`/support-faq?fid=101`, { replace: true });
      }
      return;
    }

    const prevStep = steps[targetIndex];
    navigate(`/refund?seq=${prevStep.seq}`);
  };

  // const setMixPanel = useMixpanelWeb({
  //   eventName: "환불 페이지",
  //   params: {
  //     type: `${currentStep.type}`,
  //     pageId: `${currentStep.seq}`,
  //   },
  // });
  //
  // useEffect(() => {
  //   setMixPanel();
  // }, [id]);

  const setMixPanel = useMixpanelWeb({
    eventName: "환불 신청",
    params: {
      pageId: `${seq}`,
    },
  });

  useEffect(() => {
    setMixPanel();
  }, [seq]);

  if (showNoPaymentModal) {
    return (
      <CustomModal
        open={showNoPaymentModal}
        onClose={handleExit}
        title={"환불할 결제가 없어요"}
        subtitle={"현재 환불을 신청할 결제 내역이 존재하지 않아요."}
        actions={[
          {
            label: "확인",
            onClick: handleExit,
            variant: "Solid",
          },
        ]}
      />
    );
  }

  return (
    <FullPageWithHeaderAndProgressV2
      headerTitle={currentStep.title}
      hideHeader={currentStep.hideHeader}
      hideProgress={currentStep.hideProgress}
      progress={9.1 * (currentStepIndex + 1)}
      body={currentStep.content}
      highlightBackground={currentStep.highlightBackground}
      disableBack={currentStep.disableBack}
      onBack={handleBack}
      showClose={!currentStep.hideClose}
    />
  );
}
